import _regeneratorRuntime from "/Users/Zhuanz/Desktop/source/iafme_web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/Zhuanz/Desktop/source/iafme_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
function chinaListApi() {
  return _chinaListApi.apply(this, arguments);
}
function _chinaListApi() {
  _chinaListApi = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", useGet('/web/chinaList'));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _chinaListApi.apply(this, arguments);
}
export { chinaListApi };